import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { GetBusinessEntityLocationsResponse } from './types';

export const useBusinessEntityLocations = (businessEntityId: number) => {
  const {
    data,
    error,
    mutate,
  }: {
    data: GetBusinessEntityLocationsResponse;
    error: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `business-entities/${businessEntityId}/locations`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
};
